import {UploadComponent} from "./upload.component";
import {UploadService} from "./upload.service";

export const uploadModule = angular
	.module("upload", [])
	.service("$upload", UploadService)
	.component("upload", UploadComponent);


// WEBPACK FOOTER //
// ./sources/utility/upload/upload.js